import { gql } from 'graphql-request';

export const initProdStatisticCalc = gql`
  mutation initProdStatisticCalc($prodStatisticProps: WA_InitProdStatisticInputs!) {
    wawiAssist {
      initWA_ProdStatisticCalc(prodStatisticProps: $prodStatisticProps) {
        jobId
      }
    }
  }
`;

export const getProdStatisticData = gql`
  query getProdStatisticData($jobId: String!) {
    wawiAssist {
      getWA_statisticData(jobId: $jobId) {
        data {
          ... on WA_ProductionStatisticData {
            gridData: items {
              id
              articleNo
              articleDescription
              grossSales
              quantity
              discountGroup
              productionGroup
              doughArticleId
              doughArticleNo
              doughArticleDescription
              doughWeightKg
              doughVolumeLt
              articleId
              description
              doughRequiredPerSaleUnitG
              totalDoughRequiredG
              totalDoughRequiredLt
              hasConnectionsToProductionCalc
              rawMaterialIdRA
              hfRecipeUsedAsRawMaterialIdRA
              rawMaterialNummerRA
              rawMaterialDescriptionRA
              rawMaterialWeight
              doughArticleIdWA
              doughArticleNummerWA
              doughArticleDescriptionWA
              doughWeight
            }
            summaryData {
              topArticle
              totalQuantity
              totalGrossSales
              topDough
              totalDoughKinds
              totalDoughWeight
              topRawMaterial
              totalRawMaterialKinds
              totalRawMaterialsWeight
            }
            chartsDataset {
              values
              keys
            }
          }
        }
        status
      }
    }
  }
`;
